import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=433f8614&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('433f8614')) {
      api.createRecord('433f8614', component.options)
    } else {
      api.reload('433f8614', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=433f8614&", function () {
      api.rerender('433f8614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaderboard/Index.vue"
export default component.exports